import React, { memo } from "react";
import "./style.scss";
import PropTypes from "prop-types";

export default memo(function BaseFormBlock({ children }) {
  BaseFormBlock.propTypes = {
    children: PropTypes.node,
  };
  return (
    <div className="insight-form-block">
      <div className="insight-form-block__inner">{children}</div>
    </div>
  );
});
